export const ANIMAL_SEX = {
  FEMALE: 'F',
  MALE: 'M',
  STEER: 'S',
  WETHER: 'W',
  GELDING: 'G',
  UNKNOWN: 'U',
} as const;
